
import type { CellState } from './SlotGrid.tsx';

export function cellLabelForState(
  state: CellState,
  dayLabel: string,
  timeLabel: string,
  selectedLabel: string,
): string {
  const status =
    state === 'selected'
      ? selectedLabel
      : state === 'booked'
        ? 'booked'
        : state === 'unavailable'
          ? 'unavailable'
          : state === 'disabled'
            ? 'unavailable to book'
            : 'available';
  return `${dayLabel} ${timeLabel} ${status}`;
}
